"use client"

import { useRouter } from 'next/navigation';
const LandingPageHeader = ({
    isDark = false,
    setIsDark,
    isPrivacyPage,
    setIsMobile,
    isMobile,
    setModalOpen
}) => {
    const router = useRouter();

    return (
        <>

            <div
                className={`fixed inset-x-0 top-0 z-50 backdrop-blur-xl ring-1 ${isDark
                    ? "bg-white/5 ring-white/10"
                    : "bg-white/70 ring-black/5"
                    }`}
            >

                <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex h-16 items-center justify-between">
                        <a
                            href="#"
                            className="flex items-center gap-2 font-display text-xl font-extrabold tracking-tight"
                        >
                            <span className="bg-gradient-to-r from-indigo-600 to-violet-600 bg-clip-text text-transparent">
                                <img src={isPrivacyPage || !isDark ? '/images/varnz-labs.png' : '/images/varnzLabs.png'} style={{ height: "50px" }} />
                            </span>
                            <span className="sr-only">Varnz AI Website Builder</span>
                        </a>

                        <div className="hidden md:flex items-center gap-8 group">
                            <a href="#how" className="text-sm font-medium hover:text-indigo-600">
                                How it Works
                            </a>
                            <a href="#pricing" className="text-sm font-medium hover:text-indigo-600">
                                Pricing
                            </a>
                            <a href="#features" className="text-sm font-medium hover:text-indigo-600">
                                Features
                            </a>
                            <a href="#use-cases" className="text-sm font-medium hover:text-indigo-600">
                                Use Cases
                            </a>
                            <a href="#use-cases" className="text-sm font-medium hover:text-indigo-600">
                                Greeting Cards
                            </a>
                            <a href="#use-cases" className="text-sm font-medium hover:text-indigo-600">
                                Blog
                            </a>
                        </div>

                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => setIsDark(!isDark)}
                                id="themeToggle"
                                className={`h-10 w-10 rounded-full ring-1 flex items-center justify-center transition ${isDark
                                    ? "ring-white/15 hover:bg-white/5"
                                    : "ring-slate-300/70 hover:bg-slate-50"
                                    }`}
                                aria-label="Toggle theme"
                            >
                                🌗
                            </button>

                            <a
                                href="#try"
                                data-cta="signup"
                                onClick={(e) => {
                                    e.preventDefault(); // prevent default anchor navigation
                                    const token = localStorage.getItem("auth_token");
                                    if (token) {
                                        router.push(`/`)
                                    } else {
                                        setModalOpen(true);
                                    }

                                }}
                                className={`hidden sm:inline-flex items-center justify-center rounded-full px-4 py-2 bg-gradient-to-r from-indigo-600 to-violet-600 text-white text-sm font-semibold shadow-lg hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${isDark ? "focus:ring-offset-slate-900" : ""
                                    }`}
                            >
                                Start Free
                            </a>


                            <button
                                id="menuBtn"
                                className={`md:hidden h-10 w-10 rounded-full ring-1 ${isDark
                                    ? "ring-white/15 hover:bg-white/5"
                                    : "ring-slate-300/70 hover:bg-slate-50"
                                    }`}
                                aria-label="Open menu"
                                onClick={() => {
                                    setIsMobile(!isMobile)
                                }}
                            >
                                ☰
                            </button>
                        </div>
                    </div>
                </nav>

                <div
                    id="mobileMenu"
                    className={`${isMobile ? 'block md:hidden' : 'hidden'} border-t ${isDark ? "border-white/10" : "border-slate-200/60"
                        }`}
                >
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 grid grid-cols-2 gap-3 text-sm">
                        {[
                            { href: isPrivacyPage ? "/ai-website-builder#how" : "#how", label: "How it Works" },
                            { href: isPrivacyPage ? "/ai-website-builder#pricing" : "#pricing", label: "Pricing" },
                            { href: isPrivacyPage ? "/ai-website-builder#features" : "#features", label: "Features" },
                            { href: isPrivacyPage ? "/ai-website-builder#use-cases" : "#use-cases", label: "Use Cases" },
                            { href: "/", label: "Greeting Cards", extraClass: "text-sm font-medium hover:text-indigo-600" },
                            { href: "/blog", label: "Blog", extraClass: "text-sm font-medium hover:text-indigo-600" }
                        ].map(({ href, label, extraClass }, index) => (
                            <a
                                key={index}
                                href={href}
                                className={`py-2 ${extraClass || ""}`}
                            >
                                {label}
                            </a>
                        ))}
                    </div>
                </div>
            </div>


            <div
                className={`fixed inset-x-0 top-0 z-50 backdrop-blur-xl ring-1 ${isDark
                    ? "bg-slate-900/70 text-slate-100 ring-white/10"
                    : "bg-white/70 ring-black/5"
                    }`}
            >
                <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex h-16 items-center justify-between">
                        {/* Logo */}
                        <a
                            href="/"
                            className="flex items-center gap-2 font-display text-xl font-extrabold tracking-tight"
                        >
                            <span className="bg-gradient-to-r from-indigo-600 to-violet-600 bg-clip-text text-transparent">
                                <img src={isPrivacyPage || !isDark ? '/images/varnz-labs.png' : '/images/varnzLabs.png'} style={{ height: "50px" }} />
                            </span>
                            <span className="sr-only">Varnz AI Website Builder</span>
                        </a>

                        {/* Desktop Menu */}
                        <div className="hidden md:flex items-center gap-8">
                            {[
                                { href: isPrivacyPage ? '/ai-website-builder#how' : '#how', label: "How it Works" },
                                { href: isPrivacyPage ? '/ai-website-builder#pricing' : "#pricing", label: "Pricing" },
                                { href: isPrivacyPage ? '/ai-website-builder#features' : "#features", label: "Features" },
                                { href: isPrivacyPage ? '/ai-website-builder#use-cases' : "#use-cases", label: "Use Cases" },
                            ].map((item) => (
                                <a
                                    key={item.href}
                                    href={item.href}
                                    className={`text-sm font-medium hover:text-indigo-600 ${isDark ? "hover:text-indigo-400" : ""
                                        }`}
                                >
                                    {item.label}
                                </a>
                            ))}
                        </div>

                        {/* Actions */}
                        <div className="flex items-center gap-3">
                            {
                                !isPrivacyPage &&
                                <button
                                    onClick={() => setIsDark(!isDark)}
                                    className={`h-10 w-10 rounded-full ring-1 flex items-center justify-center transition ${isDark
                                        ? "ring-white/15 hover:bg-white/10"
                                        : "ring-slate-300/70 hover:bg-slate-50"
                                        }`}
                                    aria-label="Toggle theme"
                                    aria-pressed="false"
                                >
                                    🌗
                                </button>

                            }
                            {
                                !isPrivacyPage &&
                                <a
                                    href="#try"
                                    onClick={(e) => {
                                        e.preventDefault(); // prevent default anchor navigation
                                        const token = localStorage.getItem("auth_token");
                                        if (token) {
                                            router.push(`/`)
                                        } else {
                                            // setModalOpen(true);
                                            router.push(`/`);
                                        }
                                    }}
                                    className="hidden sm:inline-flex items-center justify-center rounded-full px-4 py-2 bg-gradient-to-r from-indigo-600 to-violet-600 text-white text-sm font-semibold shadow-lg hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 test"
                                >
                                    Try it free
                                </a>
                            }

                            <button
                                id="menuBtn"
                                className={`md:hidden h-10 w-10 rounded-full ring-1 transition ${isDark
                                    ? "ring-white/15 hover:bg-white/10"
                                    : "ring-slate-300/70 hover:bg-slate-50"
                                    }`}
                                aria-label="Open menu"
                                onClick={() => {
                                    setIsMobile(!isMobile)
                                }}
                            >
                                ☰
                            </button>
                        </div>
                    </div>

                </nav>

                {/* Mobile Menu */}
                <div
                    id="mobileMenu"
                    className={`hidden md:hidden border-t ${isDark
                        ? "border-white/10 bg-slate-900"
                        : "border-slate-200/60 bg-white"
                        }`}
                >
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 grid grid-cols-2 gap-3 text-sm">
                        {[
                            { href: isPrivacyPage ? '/ai-website-builder#features' : "#features", label: "Features" },
                            { href: isPrivacyPage ? '/ai-website-builder#how' : '#how', label: "How it Works" },
                            { href: isPrivacyPage ? '/ai-website-builder#pricing' : "#pricing", label: "Pricing" },
                            { href: isPrivacyPage ? '/ai-website-builder#seo' : "#seo", label: "SEO" },
                            { href: isPrivacyPage ? '/ai-website-builder#use-cases' : "#use-cases", label: "Use Cases" },
                            { href: isPrivacyPage ? '/ai-website-builder#try' : "#try", label: "Try It", highlight: true },
                        ].map((item) => (
                            <a
                                key={item.href}
                                href={item.href}
                                className={`py-2 ${item.highlight
                                    ? isDark
                                        ? "text-indigo-300 font-semibold"
                                        : "text-indigo-700 font-semibold"
                                    : isDark
                                        ? "hover:text-indigo-400"
                                        : "hover:text-indigo-600"
                                    }`}
                            >
                                {item.label}
                            </a>
                        ))}
                    </div>
                </div>
            </div>

        </>
    )
}

export default LandingPageHeader